module.exports = __webpack_public_path__ + "static/img/vladimirTopRight.7ebd0a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/romboTeam/Vladimir/vladimirTopRight.png
// module id = 550
// module chunks = 1